interface Props {
  xAxisField: string;
  xAxisFieldName: string;
  groupByFieldType: string;
  colorKey?: string;
  [key: string]: any;
}

export default function GroupedChartTooltip({
  xAxisField,
  xAxisFieldName,
  colorKey = "fill",
  groupByFieldType,
  ...props
}: Props) {
  const payload = props?.payload;
  const originalPayload = payload?.[0]?.payload;

  if (!payload || !originalPayload) return null;

  return (
    <div className="bg-white px-4 py-3 rounded-sm border">
      <div className="font-weight-500 text-sm mb-2 text-center">
        {xAxisFieldName}: {originalPayload[xAxisField]}
      </div>
      {payload.map((p: any, i: number) => {
        const value =
          groupByFieldType === "Tags" ? p.payload[p.name].Name : p.name;

        return (
          <div
            className="bg-white rounded-sm px-4 py-2 d-flex align-items-center btn-oauth"
            key={p?.[colorKey] || i}
          >
            {p?.[colorKey] && (
              <div
                style={{
                  height: 18,
                  width: 18,
                  backgroundColor: p?.[colorKey],
                  marginRight: 10,
                }}
              ></div>
            )}
            <p className="my-0 text-sm">
              <span className="font-weight-500 text-dark">{value}</span>:{" "}
              <span className="font-weight-600">
                {typeof p?.value === "object" && p?.value !== undefined
                  ? p?.value?.Symbol + p?.value?.Value
                  : p?.value}
              </span>
            </p>
          </div>
        );
      })}
    </div>
  );
}
